export default __webpack_public_path__ + "static/media/benefit1.29191624.svg";